module.exports = __webpack_public_path__ + "static/img/6781_phase_function_Paper_PointsHejduk_Prediction.a062a03.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/6781_phase_function_Paper_PointsHejduk_Prediction.png
// module id = zqBi
// module chunks = 0